import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=cff3c648&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cff3c648')) {
      api.createRecord('cff3c648', component.options)
    } else {
      api.reload('cff3c648', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=cff3c648&", function () {
      api.rerender('cff3c648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23hFhlu25PbqV/JS/comp/ImgFallback.vue"
export default component.exports